import type { DefaultTheme } from 'styled-components';

type PaletteProps = {
  theme: DefaultTheme;
  palette?: string;
  tone?: number;
};

type PaletteValue = string | ((props: PaletteProps) => string);
type PaletteScale = PaletteValue | PaletteValue[];

const toArray = (arg: PaletteScale) => (Array.isArray(arg) ? arg : [arg]);

const clamp = (number: number, min: number, max: number) => {
  if (number < min) {
    return min;
  }
  if (number > max) {
    return max;
  }

  return number;
};

export const palette =
  (keyOrTone: string | number, toneOrDefaultValue?: number | string, defaultValue?: string) =>
  (props: PaletteProps): PaletteValue => {
    const key = typeof keyOrTone === 'string' ? keyOrTone : props.palette;
    const tone =
      typeof keyOrTone === 'number'
        ? keyOrTone
        : typeof toneOrDefaultValue === 'number'
          ? toneOrDefaultValue
          : props.tone || 0;
    const finalDefaultValue = toneOrDefaultValue !== tone ? toneOrDefaultValue : defaultValue;

    const paletteMap = props.theme.palette as Record<string, PaletteScale> | undefined;

    if (!paletteMap || !key || !paletteMap[key]) {
      return (finalDefaultValue as string) || '';
    }

    const tones = toArray(paletteMap[key]);

    if (tone < 0) {
      return tones[clamp(tones.length + tone, 0, tones.length - 1)];
    }

    return tones[clamp(tone, 0, tones.length - 1)];
  };
